/**
 * WorkflowExecutionDetailPage
 *
 * Page for viewing workflow execution details.
 */
import { BrandMark } from '../components/BrandMark';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { UserMenu } from '../components/common/UserMenu';
import { WorkflowExecutionDetail } from '../components/workflow/WorkflowExecutionDetail';

export default function WorkflowExecutionDetailPage() {
  const user = useAuthStore((state) => state.user);
  const { workflowId, executionId } = useParams<{ workflowId: string; executionId: string }>();

  if (!workflowId || !executionId) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-4">
        <div className="max-w-4xl mx-auto py-8 text-center">
          <p className="text-muted-foreground">Invalid execution URL</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Navigation Header */}
      <header className="border-b bg-white sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-6">
            <Link to="/dashboard" className="flex items-center space-x-2 hover:opacity-80 transition-opacity">
              <BrandMark className="h-7 w-7" />
              <span className="text-xl font-bold">AgentMesh</span>
            </Link>
            <nav className="hidden md:flex items-center space-x-4">
              <Link
                to="/dashboard"
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Dashboard
              </Link>
              <Link
                to="/agents"
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Agents
              </Link>
              <Link
                to="/workflows"
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Workflows
              </Link>
              <Link
                to="/executions"
                className="text-sm font-medium text-foreground"
              >
                Executions
              </Link>
              <Link
                to="/templates"
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Marketplace
              </Link>
            </nav>
          </div>
          <div className="flex items-center space-x-4">
            {user && (
              <span className="text-sm text-muted-foreground hidden sm:inline">
                {user.email}
              </span>
            )}
            <UserMenu />
          </div>
        </div>
      </header>

      <div className="p-4">
        <div className="max-w-4xl mx-auto py-8">
          <WorkflowExecutionDetail
            workflowId={workflowId}
            executionId={executionId}
          />
        </div>
      </div>
    </div>
  );
}
